import { query_work_org_by_zhaxian_list } from 'liyu-pc-base/api/org-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
    },
    watch: [],
  };

  return {
    getData: query_work_org_by_zhaxian_list,
    searchConfig: search_config,
  };
};
